import {
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from '@mui/material'
import React, { useEffect, useState } from 'react'
import { userAssignmentService } from '../../../../../services/userAssignmentService'
import { useAuthContext } from '../../../../../hooks/useAuthContext'
import DuplicateAssignmentResolveModal from './DuplicateAssignmentResolveModal'
import { arraysHaveSameElements, getAssignedDataIdsValues } from '../utils/utils'
import { getUnAssignedCombination } from '../UserActivityAssignments'

const SelectCombinationModal = ({
  listDataCombinations = [],
  openDialog,
  setOpenDialog,
  assignee,
  activityTemplateId,
  userAssignmentData = [],
  setUserAssignmentData,
  userTeamData,
  assignmentFieldData,
  unassignedData,
  setAssignedFieldData,
  setUnassignedData,
}) => {
  const { user } = useAuthContext()

  const [selectedRows, setSelectedRows] = useState([])
  const [searchQuery, setSearchQuery] = useState({})
  const [filteredIndex, setFilteredIndex] = useState([])
  const [duplicateAssignments, setDuplicateAssignments] = useState([])
  const [openDuplicateResolve, setOpenDuplicateResolve] = useState(false)
  const [buttonLoading, setButtonLoading] = useState(false)

  useEffect(() => {
    // Get Already Selected Combination of the assignee
    let userDatum = userAssignmentData?.find((user) => user.user_id == assignee?.id)

    if (userDatum) {
      let dataIds = userDatum?.assignments?.data_ids

      if (dataIds && dataIds?.length > 0) {
        let prevSelectedRows = []

        dataIds.forEach((idCombination) => {
          listDataCombinations.forEach((combination, index) => {
            let listDataIdCombination = combination.map((it) => it.list_data_id)
            if (arraysHaveSameElements(idCombination, listDataIdCombination)) {
              prevSelectedRows.push(index)
            }
          })
        })
        setSelectedRows(prevSelectedRows)
      }
    }
  }, [openDialog])

  const handleModalClose = () => {
    if (!buttonLoading) {
      setSelectedRows([])
      setSearchQuery({})
      setOpenDialog(false)
    }
  }

  const handleSelectAll = (e) => {
    if (filteredIndex.length == listDataCombinations.length) {
      if (e.target.checked) {
        let newSelectedRows = filteredIndex.map((i) => i)
        setSelectedRows(newSelectedRows)
      } else {
        setSelectedRows([])
      }
    } else {
      if (e.target.checked) {
        let newSelectedRows = filteredIndex.map((i) => i)
        setSelectedRows([...new Set([...selectedRows, ...newSelectedRows])])
      } else {
        setSelectedRows(selectedRows.filter((it) => !filteredIndex.includes(it)))
      }
    }
  }
  const handleRowSelection = (index) => {
    if (selectedRows.includes(index)) {
      setSelectedRows(selectedRows.filter((i) => i != index))
    } else {
      setSelectedRows([...selectedRows, index])
    }
  }

  const onSave = async () => {
    setButtonLoading(true)

    // Get Assignment Field Ids
    const assignmentFieldTemplateIds = listDataCombinations[0].map((it) => it.field_template_id)

    // Get Selected Combination Ids
    const dataCombinationIds = selectedRows.reduce((acc, selectedIndex) => {
      const combination = listDataCombinations[selectedIndex]
      if (combination) {
        let dataIds = combination?.map((item) => item.list_data_id)
        acc.push(dataIds)
      }
      return acc
    }, [])

    // Continue with the user assignment logic
    let userDatum = userAssignmentData?.find((user) => user.user_id == assignee.id)

    let updatedUserAssignmentData = []
    if (!userDatum) {
      userDatum = {
        assignment_for_activity_id: activityTemplateId,
        assignments: {
          field_template_ids: assignmentFieldTemplateIds,
          data_ids: dataCombinationIds,
        },
        user_id: assignee.id,
      }
      updatedUserAssignmentData = [...userAssignmentData, userDatum]
      setUserAssignmentData([...userAssignmentData, userDatum])
    } else {
      updatedUserAssignmentData = userAssignmentData.map((user) => {
        if (user.user_id == assignee.id) {
          return {
            ...user,
            assignments: {
              field_template_ids: assignmentFieldTemplateIds,
              data_ids: dataCombinationIds,
            },
          }
        }
        return user
      })
      setUserAssignmentData(updatedUserAssignmentData)
    }

    const unassignedData = getUnAssignedCombination(listDataCombinations, updatedUserAssignmentData)
    setUnassignedData(unassignedData)

    // Save the assignments via API
    await userAssignmentService.saveUserActivityAssignments(user, {
      assignee_id: assignee.id,
      activity_template_id: activityTemplateId,
      assignments: { field_template_ids: assignmentFieldTemplateIds, data_ids: dataCombinationIds },
    })

    setButtonLoading(false)
    handleModalClose()
  }

  const handleSearch = (e, index) => {
    setSearchQuery({ ...searchQuery, ['sq_' + index]: e.target.value })
  }

  function findDuplicates(arr) {
    // Create an object to count occurrences
    const count = {}
    arr.forEach((num) => {
      count[num] = (count[num] || 0) + 1
    })

    // Filter out the duplicates
    const duplicates = arr.filter((num) => count[num] > 1)

    // Check if there are duplicates
    if (duplicates.length > 0) {
      // Remove duplicates from the duplicates array
      const uniqueDuplicates = [...new Set(duplicates)]
      return uniqueDuplicates
    } else {
      return arr
    }
  }

  useEffect(() => {
    let filteredIndex = []
    Object.keys(searchQuery).forEach((key) => {
      let queryingIndex = key.split('_')[1]

      listDataCombinations.forEach((combination, index) => {
        if (
          combination[Number(queryingIndex)].list_data_value
            .toLowerCase()
            .includes(searchQuery[key].toLowerCase())
        ) {
          filteredIndex.push(index)
        }
      })
    })
    if (Object.keys(searchQuery).length > 0) {
      setFilteredIndex(findDuplicates(filteredIndex))
    } else {
      setFilteredIndex(listDataCombinations.map((_, index) => index))
    }
  }, [searchQuery])

  const getDuplicatesAssignments = () => {
    // Get Selected Combination Ids
    const dataCombinationIds = selectedRows.reduce((acc, selectedIndex) => {
      const combination = listDataCombinations[selectedIndex]
      if (combination) {
        let dataIds = combination?.map((item) => item.list_data_id)
        acc.push(dataIds)
      }
      return acc
    }, [])

    let duplicates = new Map()
    userAssignmentData.forEach((userDatum) => {
      let userAssignments = userDatum?.assignments?.data_ids

      if (userDatum.user_id != assignee.id && userAssignments) {
        userAssignments.forEach((idCombination) => {
          dataCombinationIds.forEach((idCombination2) => {
            if (arraysHaveSameElements(idCombination2, idCombination)) {
              if (duplicates.has(userDatum.user_id)) {
                duplicates.set(userDatum.user_id, [
                  ...duplicates.get(userDatum.user_id),
                  idCombination,
                ])
              } else {
                duplicates.set(userDatum.user_id, [idCombination])
              }
            }
          })
        })
      }
    })

    if (duplicates.size > 0) {
      let duplicatesArray = []

      for (let [key, values] of duplicates) {
        let userDatum = userTeamData.find((it) => it.user_id == key)
        values.forEach((value) => {
          duplicatesArray.push({
            user_id: userDatum.user_id,
            user_name: `${userDatum.first_name} ${userDatum.last_name} - (${userDatum.email})`,
            combinationIds: value,
            combinationValues: getAssignedDataIdsValues(value, assignmentFieldData),
            currentUserDataCombinationIds: dataCombinationIds,
          })
        })
      }
      setDuplicateAssignments(duplicatesArray)
      setOpenDuplicateResolve(true)
    } else {
      onSave()
    }
  }

  return (
    <>
      <Dialog
        open={openDialog}
        onClose={handleModalClose}
        fullWidth
        maxWidth="lg"
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          Select Assignment Combinations for{' '}
          <span style={{ fontWeight: 'bold' }}>
            {assignee?.first_name} {assignee?.last_name}
          </span>
        </DialogTitle>
        <DialogContent>
          <TableContainer component={Paper} style={{ maxHeight: 500 }}>
            <Table stickyHeader sx={{ minWidth: 650, maxHeight: 500 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell padding="checkbox">
                    <Checkbox
                      color="primary"
                      indeterminate={
                        filteredIndex.length == listDataCombinations.length
                          ? selectedRows.length > 0 &&
                            selectedRows.length < listDataCombinations.length
                          : false
                      }
                      onClick={(e) => handleSelectAll(e)}
                    />
                  </TableCell>
                  {listDataCombinations[0]?.map((item) => (
                    <TableCell key={'th_' + item.list_data_id}>
                      <Typography fontWeight="bold" variant="subtitle2">
                        {item.field_template_name}
                      </Typography>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell></TableCell>
                  {listDataCombinations[0]?.map((item, i) => (
                    <TableCell key={'th_' + item.list_data_id}>
                      <TextField
                        key={'sq_' + item.list_data_id}
                        onChange={(e) => handleSearch(e, i)}
                        type="search"
                        size="small"
                        fullWidth
                        color="primary"
                        margin="dense"
                      />
                    </TableCell>
                  ))}
                </TableRow>
                {listDataCombinations.map((combination, index) => (
                  <>
                    {filteredIndex.includes(index) ? (
                      <>
                        <TableRow
                          sx={{ cursor: 'pointer' }}
                          role="checkbox"
                          hover
                          tabIndex={-1}
                          key={'tr' + index}
                          onClick={() => {
                            handleRowSelection(index)
                          }}
                          style={
                            selectedRows.includes(index)
                              ? { backgroundColor: 'rgba(236, 225, 238, 0.55)' }
                              : null
                          }
                        >
                          <TableCell component="th" scope="row">
                            <Checkbox
                              color="primary"
                              onClick={() => handleRowSelection(index)}
                              checked={selectedRows.includes(index)}
                              inputProps={{
                                'aria-labelledby': index,
                              }}
                            />
                          </TableCell>
                          {combination.map((item) => (
                            <TableCell
                              component="th"
                              key={'tc' + item.list_data_id}
                              padding="none"
                              scope="row"
                            >
                              {item.list_data_value}
                            </TableCell>
                          ))}
                        </TableRow>
                      </>
                    ) : null}
                  </>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions>
          <Button color="primary" variant="outlined" onClick={handleModalClose}>
            Cancel
          </Button>
          <Button
            color="primary"
            variant="contained"
            disabled={buttonLoading}
            onClick={getDuplicatesAssignments}
          >
            {buttonLoading ? <CircularProgress size="23px" color="inherit" /> : <>Save</>}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Resolve Duplicate Assignments Dialog */}
      {openDuplicateResolve ? (
        <DuplicateAssignmentResolveModal
          openDuplicateResolve={openDuplicateResolve}
          setOpenDuplicateResolve={setOpenDuplicateResolve}
          duplicateAssignments={duplicateAssignments}
          assignee={assignee}
          setUserAssignmentData={setUserAssignmentData}
          userAssignmentData={userAssignmentData}
          handleSelectCombinationModalClose={handleModalClose}
          activityTemplateId={activityTemplateId}
        />
      ) : null}
    </>
  )
}

export default SelectCombinationModal
